import {ThemeModeType} from '../../../_metronic/partials'

const DYNAMIC_COLORS_ID = "dynamic_colors"

export type Color = {
  name: string,
  value: string,
  isDarkTheme: boolean,
  context?: string
}

export const setDynamicColors = (colors?: Color[]) => {
  let rootElementPath: string
  let themeMode: ThemeModeType
  let styles = '';
  colors?.forEach(({name, value, isDarkTheme, context}) => {
    themeMode = isDarkTheme ? 'dark' : 'light'
    rootElementPath = `[data-app-theme=custom][data-theme=${themeMode}] #kt_app_body`
    if (context) {
      rootElementPath += ` ${context}`
    }
    styles += `
        ${rootElementPath} {
          ${name}: ${value};
        }
      `
  })
  const styleElement = document.getElementById(DYNAMIC_COLORS_ID)
  if (styleElement) {
    styleElement.innerHTML = styles
  } else {
    const style = document.createElement('style')
    style.innerHTML = styles
    style.id = DYNAMIC_COLORS_ID
    document.head.appendChild(style)
  }
}